<SvelteMarkdown {source} />

<script>
  import SvelteMarkdown from 'svelte-markdown';

  const source = `
  BRILLIANCE LABS, WEBFORMA, SAAS TERMS OF SERVICE AGREEMENT
SOFTWARE AS A SERVICE (“SAAS “)
TERMS OF SERVICE FOR END-USERS
THE SERVICE PROVIDERS (DEFINED BELOW) ARE WILLING TO GRANT YOU RIGHTS
TO ESTABLISH AN ACCOUNT AND TO USE THE WEB SERVICES (DEFINED BELOW)
ONLY UPON THE CONDITION THAT YOU ACCEPT ALL OF THE TERMS CONTAINED IN
THIS AGREEMENT. PLEASE READ THE SERVICE AGREEMENT CAREFULLY. BY
CLICKING ON "I ACCEPT", YOU WILL INDICATE YOUR AGREEMENT WITH THEM. IF YOU
ARE ENTERING INTO THIS AGREEMENT ON BEHALF OF A COMPANY OR OTHER
LEGAL ENTITY OR PERSON, YOUR ACCEPTANCE REPRESENTS THAT YOU HAVE THE
AUTHORITY TO BIND SUCH ENTITY OR PERSON TO THESE TERMS. IF YOU DO NOT
AGREE WITH THESE TERMS, OR IF YOU DO NOT HAVE THE AUTHORITY TO BIND
YOUR ENTITY OR PERSON, THEN THE SERVICE PROVIDERS ARE UNWILLING TO
GRANT YOU RIGHTS TO ACCESS AND USE THE WEB SERVICES.
SAAS TERMS OF SERVICE AGREEMENT
Effective Date as of first day Results services commence.
1. Definitions.
1.1 Parties.
1.1.1 This is an agreement by and among the originator of the Web Services (the
Primary Service Provider), the party that offered and sold you the Web Services (the
‚Secondary Service Provider, which will be Results.com or a Results.com authorized reseller),
and you.
1.1.2 Both the Primary Service Provider and the Secondary Service Provider will be
referred to collectively as the Service Provider, and both will have full rights to enforce this
Agreement. All references to "we", "us", and "our‚ shall be construed to mean the Service
Provider.
1.1.3 If you are not acting on behalf of yourself as an individual, then "you", "your",
“customer”, and "yourself" means your company or organization or the person you are
representing. The company or organization you represent will be the one registered and
paying for the web services specified as part of the Purchase Agreement.
2014 SAAS TERMS OF SERVICE AGREEMENT
1.1.4 Results.com includes Results.com Ltd (a New Zealand limited liability company), its
subsidiary and joint venture partner companies. North American based clients will be deemed
to have purchased the web service via Results.com USA Inc. a Results.com Ltd subsidiary.
1.2 "Web Services." The web services described and specified as part of the
Purchase Agreement and any updates or upgrades to such services which may be generally
released by Results to all customers from time to time.
1.3 "Results Technology." The computer hardware, software and other tangible
equipment and intangible computer code necessary to deploy and serve the Services via the
Site.
1.4 "Site." Results’ www.results.com website including the Results Technology.
1.5 "Authorized Users." The number of identifiable unique persons consisting of your
personnel and outside consultants who are authorized to access and use the Services as
determined by you but not exceeding the maximum number of users paid for. Authorized
Users may include your third party consultants, outsourcers, contractors and other service
providers.
1.6 "Affiliate." With respect to you, any parent or subsidiary corporation, and any
corporation or other business entity controlling, controlled by or under common control with
you, which agrees in writing to be bound by all your obligations hereunder.
1.7 "Customer Data." Customer’s information or other data processed, stored or
transmitted by, in or through the Services, including without limitation personal information
relating to the Customer’s personnel, customers, and prospective customers such that the
identity of such persons is apparent or can reasonably be determined from such personal
information.
1.8 "Proprietary Rights." Any and all rights, whether registered or unregistered, in
and with respect to patents, copyrights, confidential information, know-how, trade secrets,
moral rights, contract or licensing rights, confidential and proprietary information protected
under contract or otherwise under law, trade names, domain names, trade dress, logos,
animated characters, trademarks, service marks, and other similar rights or interests in
intellectual or industrial property.
2014 SAAS TERMS OF SERVICE AGREEMENT
1.9 “Purchase Agreement”. Details of the purchase and Web Services required are
agreed verbally and based on the terms, fees prevailing at that time on Results’ website
www.results.com. Confirmation that the customer wishes to proceed and commit to an annual
subscription service is deemed to have taken place when the periodic subscription fee has
been paid.
2. Agreement.
2.1 This Agreement between you and the Service Provider consists of this Terms of
Service Agreement.
2.2 This Agreement between you and the Service Providers is also subject to their
respective Privacy Policies. These can be viewed at their websites. The Primary Service
Provider’s Privacy Policy can be viewed at www.results.com.
3. Modification of Agreement. We reserve the right to modify this Agreement at any time
by posting an amended Agreement that is always accessible through links placed on one of
the Web Services or login pages and/or by giving you prior notice of a modification. You should
check this Agreement periodically for modifications by scrolling to the bottom of this page for a
listing of material modifications and their effective dates. IF ANY MODIFICATION IS
UNACCEPTABLE TO YOU, YOUR ONLY RECOURSE IS TO TERMINATE THIS
AGREEMENT. YOUR CONTINUED USE OF THIS SITE FOLLOWING OUR POSTING OF AN
AMENDED AGREEMENT OR PROVIDING YOU NOTICE OF A MODIFICATION WILL
CONSTITUTE BINDING ACCEPTANCE.
4. Eligibility. Web Services are not available to minors under the age of 18 years of age
and any user that has been suspended or removed from the system.
5. Web Services. Web Services consist of Results.com software, rule-based, Business
Execution Software, incorporating the Results strategy center that the Backend Services
Provider provides through its website. We reserve the right to update and modify the Services
from time to time.
2014 SAAS TERMS OF SERVICE AGREEMENT
6. Use and Restrictions. Subject to the terms and conditions of this Agreement, you may
access and use the Web Services only through the login protocols provided to you, but only for
your own internal purposes. All rights not expressly granted in this Agreement are reserved by
the Service Providers and their licensors.
6.1 You will be granted authorized login protocols for the Web Services, and you
agree not to use the Web Services in excess of your authorized login protocols. You agree not
to access (or attempt to access) the Web Services by any means other than through the login
protocols we provide. You agree not to access (or attempt to access) the Web Services
through any automated means (including use of scripts or web crawlers), and you agree to
comply with the instructions set out in any robots.txt file present on the Web Services.
6.2 You are not authorized to (i) resell, sublicense, transfer, assign, or distribute the
Web Services or content; (ii) modify or make derivative works based upon the Web Services or
content; (iii) "frame" or "mirror" the Web Services or content on any other server or Internetenabled device, or (iv) reverse engineer, decompile the Web Services or their enabling
software for any purpose.
6.3 You are not authorized to use our Web Services or servers for the propagation,
distribution, housing, processing, storing, or otherwise handling in any way lewd, obscene, or
pornographic material, or any other material which we deem to be objectionable. The
designation of any such materials is entirely at our sole discretion.
7. Inquiries Regarding Web Services. You agree to make all inquiries regarding the Web
Services and technical support directly to the Primary Service Provider.
8. Ownership. The software and technology used by the Primary Service Provider to
generate and provide the Web Services are protected by law, including, but not limited to,
United States copyright law and international treaties. The copyrights and other intellectual
property rights in this material are owned by the Primary Service Provider and/or others.
Except for the limited rights granted herein, all other rights are reserved.
9. Termination. You agree that we may terminate your account and access to the Web
Services for cause without prior notice, upon the occurrence of any one of the following: (i) any 
2014 SAAS TERMS OF SERVICE AGREEMENT
material breach of this Agreement, or (ii) requests by law enforcement or other government
agencies. Termination of your account includes (i) removal of access to all Web Services, and
(ii) deletion of your login protocols. Further, you agree that all terminations shall be made in our
sole discretion, and that we will not be liable to you or any third-party for any termination of
your account or access to Web Services and/or data that you lose access too.
10. Your Account-Related Responsibilities. You are responsible for maintaining the
confidentiality of your login protocols, and any additional information that we may provide
regarding accessing the Web Services. If you knowingly share your login protocols with
another person who is not authorized to use the Web Services, this Agreement is subject to
termination for cause. You agree to immediately notify us of any unauthorized use of your login
protocols or any other breach of security.
11. Mutual Exchange of Confidential Information. The parties anticipate that each may
disclose confidential information to the other. Accordingly, the parties desire to establish in this
Section terms governing the use and protection of certain information one party ("Owner") may
disclose to the other party ("Recipient").
11.1 Definition of Confidential Information. For purposes hereof, "Confidential
Information" means (i) the terms and conditions hereof, (i) non-public aspects of Results’ Site
and the operation thereof, Results Technology, and the Services and additional services
provided by Results, and Results’ business and technical information, and data, (iii) Customer
Data, and non-public aspects of Customer’s technology, computer programs, and business
and technical information, and data. In addition, Confidential Information includes information
which, although not related to the Services or this Agreement, is nevertheless disclosed
hereunder, and which, in any case, is disclosed by an Owner or its affiliate to Recipient in
document or other tangible form bearing an appropriate legend indicating its confidential or
proprietary nature, or which, if initially disclosed orally or visually is identified as confidential at
the time of disclosure and a written summary hereof, also marked with such a legend, is
provided to Recipient within fifteen (15) days of the initial disclosure.
11.2 Restrictions on Use and Disclosure. Recipient may use Confidential Information
of Owner only for the purposes of this Agreement and shall protect such Confidential
Information from disclosure to others, using the same degree of care used to protect its own
proprietary information of like importance, but in any case using no less than a reasonable
degree of care. Recipient may disclose Confidential Information received hereunder only as
reasonably required to perform its obligations under this Agreement and only to its employees
who have a need to know for such purposes and who are bound by signed, written
agreements to protect the received Confidential Information from unauthorized use and
disclosure. 
2014 SAAS TERMS OF SERVICE AGREEMENT
11.3 Exclusions. The restrictions of this Agreement on use and disclosure of
Confidential Information shall not apply to information that: (i) is in the possession or control of
Recipient at the time of its disclosure hereunder; (ii) is, or becomes publicly known, through no
wrongful act of Recipient; (iii) is received by Recipient from a third party free to disclose it
without obligation to Owner, (iv) is independently developed by a party as evidenced by its
written and dated records and without any breach of this Agreement; or (v) is the subject of a
written permission to disclose provided by Owner. The Recipient may disclose Confidential
Information of Owner pursuant to the requirements of a governmental agency or by operation
of law, provided that such Recipient gives Owner written notice thereof as soon as practicable
and reasonably cooperates with Owner to contest such disclosure.
11.4 Confidential Information. You agree that all non-public information that we
provide regarding the Web Services, including without limitation, our pricing, marketing
methodology, and business processes, is our proprietary confidential information. You agree to
use this confidential information only for purposes of exercising your rights as our affiliate while
in strict compliance with this Agreement, and you further agree not to use or disclose this
confidential information for a period of three (3) years after termination as our affiliate.
12. Disclaimer of Actions of Third Parties. Results does not and cannot control the flow of
data to or from Results’ Technology and other portions of the Internet. Such flow of data
depends on the performance of Internet services provided or controlled by third parties. At
times, actions or inactions of such third parties can impair or disrupt customer’s connections to
the Internet (or portions thereof). Although Results will use commercially reasonable efforts to
take all actions it deems appropriate to remedy and avoid such events, Results cannot
guarantee that such events will not occur. RESULTS DISCLAIMS ANY AND ALL LIABILITY
RESULTING FROM OR RELATED TO THE PERFORMANCE OR NON-PERFORMANCE OF
INTERNET SERVICES PROVIDED OR CONTROLLED BY THIRD PARTIES.
13. Onward Transfer of Personal Information outside Your Country of Residence. Any
personal information which we may collect on the Web Services will be stored and processed
in our servers located only in Canada. If you reside outside of Canada, you consent to the
transfer of personal information outside your country of residence to Canada.
14. Export Control. We provide Web Services and use software and technology that may
be subject to United States export controls administered by the U.S. Department of
Commerce, the United States Department of Treasury Office of Foreign Assets Control, and
other U.S. agencies and the export control regulations of Switzerland and the European Union.
You acknowledge and agree that the Web Services shall not be used in, and none of the
underlying information, software, or technology may be transferred or otherwise exported or re-
2014 SAAS TERMS OF SERVICE AGREEMENT
exported to, countries to which the United States, Switzerland and/or the European Union
maintains an embargo (collectively, "Embargoed Countries"), or to or by a national or resident
thereof, or any person or entity on the U.S. Department of Treasury's List of Specially
Designated Nationals or the U.S. Department of Commerce's Table of Denial Orders
(collectively, "Designated Nationals"). The lists of Embargoed Countries and Designated
Nationals are subject to change without notice. By using the Web Services, you represent and
warrant that you are not located in, under the control of, or a national or resident of an
Embargoed Country or Designated National. You agree to comply strictly with all U.S., Swiss
and European Union export laws and assume sole responsibility for obtaining licenses to
export or re-export as may be required.
15. Registration Data. Registration is required for you to establish an account at the Web
Services. You agree (i) to provide certain current, complete, and accurate information about
you as prompted to do so by our online registration form ("Registration Data"), and (ii) to
maintain and update such Registration Data as required to keep such information current,
complete and accurate. You warrant that your Registration Data is and will continue to be
accurate and current, and that you are authorized to provide such Registration Data. You
authorize us to verify your Registration Data at any time. If any Registration Data that you
provide is untrue, inaccurate, not current or incomplete, we retain the right, in its sole
discretion, to suspend or terminate rights to use your account. Solely to enable us to use
information you supply us internally, so that we are not violating any rights you might have in
that information, you grant to us a nonexclusive license to (i) convert such information into
digital format such that it can be read, utilized and displayed by our computers or any other
technology currently in existence or hereafter developed capable of utilizing digital information,
and (ii) combine the information with other content provided by us in each case by any method
or means or in any medium whether now known or hereafter devised.
16. Monitoring. We reserve the right to monitor your access and use of the Web Services
without notification to you.
17. Security. You shall be solely responsible for acquiring and maintaining technology and
procedures for maintaining the security of your link to the Internet. As part of the Web
Services, the Service Provider shall implement reasonable and appropriate security
procedures consistent with prevailing industry standards to protect data from unauthorized
access by physical and electronic intrusion; provided, however, unless resulting from the
failure of Service Provider to perform the forgoing obligations, the parties agree that Service
Provider shall not, under any circumstances, be held responsible or liable for situations (i)
where data or transmissions are accessed by third parties through illegal or illicit means, or (ii)
where the data or transmissions are accessed through the exploitation of security gaps,
weaknesses, or flaws unknown to Service Provider at the time. Service Provider will promptly
report to you any unauthorized access to your data promptly upon discovery by Service
Provider, and Service Provider will use diligent efforts to promptly remedy any breach of 
2014 SAAS TERMS OF SERVICE AGREEMENT
security that permitted such unauthorized access. In the event notification to persons included
in your data is required, you shall be solely responsible for any and all such notifications at
your expense.
18. Backups. At no additional charge to Customer, Results shall make daily incremental
Backups (the "Incremental Backup") and weekly full backups (the "Full Backups") of Customer
Data archived with the Results Technology. The prior day incremental backup and a copy of
the weekly backup shall be stored off-site in a secure facility designed to store and maintain
backups for emergency use. Upon storage of a weekly backup in the off-site facility, the prior
weekly backup shall be made available to Customer by electronic delivery. Requests for
Customer data need to be made to Results fourteen (14) days before the termination of this
agreement at additional cost to the Customer on a times and materials basis. Customer data
will be made available in a standard database document. Customer Data will be released only
if Customer is current on all payments.
19. No Commingling of Customer Data. The Services shall be operated in an environment
where (i) all Customer Data shall be stored on files totally separate from those of other
customers of Results, or (ii) all files containing Customer Data are partitioned sufficient to
protect the security and privacy of Customer Data
20. Subscription License Term; Fees
20.1 Subscription Term. The initial term of this web service shall commence as of the
Effective Date hereof and shall continue for a period of one year, unless specified otherwise.
The initial term hereof shall automatically renew for successive one (1) year terms unless
either party notifies the other in writing not less than thirty (30) days prior to the expiration of
the current term of its intention not to renew. Both the initial term and any renewal term are
subject to earlier termination as otherwise provided herein. Either party may choose not to
renew this Agreement without cause for any reason.
20.2 Subscription Fees and Payment Terms. The periodic subscription license fees
shall be payable on an annual basis, in advance, unless agreed otherwise. Periodic
subscription license fee payments shall be as per the rate on Results’ website
www.results.com at period commencement whether that be the initial term or renewal period.
The subscription fee will be calculated based on the number of users required forming part of
the Purchase Agreement. The initial number of users can only be reduced at the renewal date
providing you notify Results in writing not less than thirty (30) days prior to the expiration of the
current term
2014 SAAS TERMS OF SERVICE AGREEMENT
20.3 Additional Users. Additional users can be added to the subscription fee during
the initial term and subsequent renewal periods. The fee for additional users will be the rate
on Results’ website www.results.com at the time of requesting additional users. The fee for
additional users remains in force until the end of the 12-month initial term or subsequent 12
months renewal term. Only at the annual renewal date can additional users be reduced back
down. Fees for additional users are payable monthly in accordance with 20.2. At the renewal
date, unless we are notified by you thirty (30) days prior to the renewal date, the additional
users will be included in the subscription license fees and payable as per 20.2.
20.3 Guaranteed Minimum Term. The initial term and subsequent renewals of this
web service are for a period of one year, unless specified otherwise. By exception some
Customers maybe granted a 6 month opt out which is at the Primary Service Provider’s sole
discretion. The 6 month opt out must be confirmed in writing by the Primary Service Provider
and retained by the Customer as evidence. To execute the 6 month opt out 30 days written
notice must be given by the Customer, along with written evidence that the Service Provider
granted the 6 month opt out, that they wish to terminate the agreement at 6 months from
commencement of the initial term. This opt out will not be granted under any circumstances
for renewal periods.
If the Customer terminates the Agreement or ceases to continue making subscription fee
payments prior to the expiration of the one (1) year term for any reason, then subscription fees
for the remainder of the initial one year term shall accelerate and become due and payable in a
lump sum immediately upon termination. If an annual fee has been paid there will be no
refund for the remainder of the term.
20.4 Fee Increases. Website operator may increase periodic subscription fees at any
time with sixty (60) days prior notice to Customer.
20.5 Late Charges. If Customer does not make timely payment to website operator of
any amount payable hereunder, in addition to the remedies available to website operator at
law or equity, website operator may collect interest on the sum then owing at the rate of 1.5%
per month from the due date until payment by Customer; provided, however, that in no event
shall the aggregate interest charges exceed the maximum rate of interest which could be
charged under applicable law.
20.6 Termination For Cause. If either party fails to comply with any of the material
terms and conditions of this Agreement, including without limitation the payment of any 
2014 SAAS TERMS OF SERVICE AGREEMENT
subscription license fee or reimbursement due and payable to Results under this Agreement,
the non-defaulting party may terminate this Agreement and any and all license rights upon
fifteen (15) days' written notice to the defaulting party specifying any such breach, unless
within the period of such notice, all breaches specified therein shall have been remedied.
20.7 There will be no refunds of any payments made in advance whatsoever. With
appropriate notice the Service Provider will stop any future scheduled payments.
21. Purchase of Additional Services. Customer may elect to purchase rights for additional
Authorized Users, Web services and/or any other Results products or services, and/ from time
to time. Such additional purchases shall be governed by the terms and conditions hereof.
22. Subscription Fees. Customer shall pay to Results periodic subscription fees for the
Services and technical support services provided hereunder in accordance with the website
www.results.com.

23. Taxes. All fees are exclusive of taxes or duties. If Results is required to pay or collect
any federal, state, local, value added, tax or duty on any fees charged under this Agreement,
or any other similar taxes or duties levied by any governmental authority, excluding taxes
levied on Results' net income, then such taxes and/or duties shall be billed to and paid by
Customer immediately upon receipt of Results' invoice and supporting documentation for the
taxes or duties charged.
24. Technical Support, Training, and Consulting Services. During the term hereof, the
service provider shall provide technical support in the form of responses to questions by email
or telephone at no additional charge. If additional services are required for the proper use and
operation of the Services or if training or consulting services are requested, the service
provider shall provide such services on a time and materials ("T&M") basis; that is, (i)
Customer shall pay the service provider for all the time spent performing such services
(including all travel time), plus materials, taxes, and reimbursable expenses; and (ii) the rates
for such services shall be the service providers then-current standard rates when such
services are provided.
25. Proprietary Rights Ownership. Ownership of the Proprietary Rights embodied in the
Site, Services, and Results Technology shall remain exclusively vested in and be the sole and
exclusive property of Results and its licensors. In addition Customer hereby transfers and 
2014 SAAS TERMS OF SERVICE AGREEMENT
assigns to Results any rights Customer may have to any suggestions, ideas, enhancement
requests, feedback, recommendations or other information provided by Customer personnel
relating to the Service. The www.results.com domain name, product names and logos
associated with the Services are trademarks of Results or third parties, and no right or license
is granted to use them.
26. Customer Representations and Warranties.
26.1 Customer represents and warrants that (i) the performance of its obligations and
use of the Services (by Customer and its Authorized Users) will not violate any applicable
laws, or regulations, including without limitation any and all laws and regulations regarding the
transfer of personal information of residents of the European Union outside the European
Union, or (ii) cause a breach of any agreements with any third parties or unreasonably interfere
with the use by other Results customers of Results services.
26.2 Customer acknowledges that (i) Results does not monitor the content of the
information passing through the Services for purposes of verifying accuracy or legal
compliance, and (ii) Customer will use commercially reasonable efforts to ensure that the
information it and its Authorized Users transmit thereby complies with all applicable laws and
regulations, whether now in existence or hereafter enacted and in force.
26.3 In the event of any breach by Customer of any of the foregoing representations
or warranties, in addition to any other remedies available at law or in equity, Results will have
the right to suspend immediately any Services if deemed reasonably necessary by Results to
prevent any harm to Results and its business. Results will provide notice to Customer and an
opportunity to cure, if practicable, depending on the nature of the breach. Once cured, Results
will promptly restore the Services.
27. Intellectual Property Indemnity. Except for third party software including without
limitation open source software, Results will indemnify, defend and hold harmless Customer
and its Affiliates from and against any lawsuit, liabilities, loss, cost or expense arising out of a
third-party claim made against Customer that the Results Technology or Services infringe on
any U.S. intellectual property right of a third party; provided, however, that Results is notified in
writing of such claim promptly after such claim is made upon Customer. Results shall have the
right to control any defense of the claim. In no event shall Customer settle any such claim
without Results' prior written approval. Results shall have no liability or obligation if the claim
arises from (i) any alteration or modification to the Results Technology or Services other than
by Results, (ii) any combination of the Results Technology or Services by Customer with other
programs or data not furnished by Results, or (iii) any use by Customer of the Results 
2014 SAAS TERMS OF SERVICE AGREEMENT
Technology or Services that is prohibited by this Agreement or otherwise outside the scope of
use for which the Results Technology or Services are intended.
28. Options for Infringement Claims. If any party is enjoined from using the Results
Technology, or if Results believes that the Results Technology may become the subject of a
claim of intellectual property infringement, Results, at its option and expense, may: (i) procure
the right for Customer to continue to use the Services; (ii) replace or modify the Results
Technology so as to make it non-infringing; provided, however, that the Services continue to
conform to the descriptions and/or specifications provided in the applicable Purchase Order; or
(iii) terminate this Agreement, in which case Results shall refund to Customer any and all
subscription fees paid in advance by Customer for those Services not provided by Results and
provide, at Customer’s request and free of charge, the Customer Data in a database document
format. This Section and the preceding Section sets forth the entire liability of Results to
Customer for any infringement by the Results Technology or Services of any intellectual
property right of any third party. Notwithstanding the foregoing, this Section does not apply to
third party software including without limitation open source software.
29. Liability Cap. Except for Results’ indemnity expressly provided herein and Results’
confidentiality obligations, in no event shall Results' aggregate liability, if any, including liability
arising out of contract, negligence, strict liability in tort or warranty, or otherwise, shall not
exceed the total of subscription fees payable by Customer for the three (3) billing periods
immediately preceding the claim for such liability.
30. Termination by Results for End of Life. Results intends to continue to provide and
support the Services for the term of this agreement; provided, however, if, Results determines
in its sole discretion that it is no longer feasible to support the Services, Results may terminate
this Agreement for end of life at any time by providing one hundred eighty (180) days written
notice to Customer.
31. Return of Materials. Within ten (10) days of the expiration or termination of this
agreement, Customer shall return to Results any materials provided by Results.
32. Assignment. Customer shall not assign this Agreement or any right or interest under
this Agreement, nor delegate any work or obligation to be performed under this Agreement,
without Results' prior written consent. Any attempted assignment or delegation in
contravention of this Section shall be void and ineffective.
2014 SAAS TERMS OF SERVICE AGREEMENT
33. Continuing Obligations. The following obligations shall survive the expiration or
termination hereof and the distribution grace period provided above: (i) any and all warranty
disclaimers, limitations of liability and indemnities granted by either party herein, (iv) any
covenant granted herein for the purpose of determining ownership of, or protecting, the
Proprietary Rights, including without limitation, the Confidential Information of either party, or
any remedy for breach thereof, and (v) the payment of taxes, duties, or any money to Results
hereunder.
34. Notices. We may give notice to you by means of (i) a general notice in your account
information, (ii) by electronic mail to your e-mail address on record in your Registration Data,
or (iii) by written communication sent by first class mail or pre-paid post to your address on
record in your Registration Data. Such notice shall be deemed to have been given upon the
expiration of forty eight (48) hours after mailing or posting (if sent by first class mail or pre-paid
post) or twelve (12) hours after sending (if sent by email). You may give notice to the Primary
Service Provider (such notice shall be deemed given when received) at any time by any of the
following: (a) by letter sent by confirmed facsimile to us at the following fax number, +64 9 361
0091; or (b) by letter delivered by nationally recognized overnight delivery service or first class
postage prepaid mail as follows: Results.com, PO Box 91232, Auckland Mail Centre, Auckland
1142, New Zealand in either case, addressed to the attention of "President of the Company".
Notices will not be effective unless sent in accordance with the above requirements.
35. Arbitration. Except for actions to protect intellectual property rights and to enforce an
arbitrator’s decision hereunder, all disputes, controversies, or claims arising out of or relating to
this Agreement or a breach thereof shall be submitted to and finally resolved by arbitration
under the rules of the American Arbitration Association ("AAA") then in effect. There shall be
one arbitrator, and such arbitrator shall be chosen by mutual agreement of the parties in
accordance with AAA rules. The arbitration shall be conducted by telephone or online. The
arbitrator shall apply the laws of New Zealand to all issues in dispute. The controversy or
claim shall be arbitrated on an individual basis, and shall not be consolidated in any arbitration
with any claim or controversy of any other party. The findings of the arbitrator shall be final
and binding on the parties, and may be entered in any court of competent jurisdiction for
enforcement. Enforcements of any award or judgment shall be governed by the United Nations
Convention on the Recognition and Enforcement of Foreign Arbitral Awards. Should either
party file an action contrary to this provision, the other party may recover attorney's fees and
costs up to $1000.00.
36. Applicable Law; Jurisdiction and Venue. This Agreement shall be construed under the
laws of New Zealand, without regard to its principles of conflicts of law. The courts of As
determined by Licensor shall be the exclusive jurisdiction and venue for all legal proceedings
that are not arbitrated under this Agreement.
2014 SAAS TERMS OF SERVICE AGREEMENT
37. Severability. If any provision of this Agreement is declared invalid or unenforceable,
such provision shall be deemed modified to the extent necessary and possible to render it valid
and enforceable. In any event, the unenforceability or invalidity of any provision shall not affect
any other provision of this Agreement, and this Agreement shall continue in full force and
effect, and be construed and enforced, as if such provision had not been included, or had been
modified as above provided, as the case may be.
38. Warranty Disclaimers. EXCEPT AS MAY BE PROVIDED IN ANY SEPARATE
WRITTEN AGREEMENTS SIGNED BY THE PARTIES, THE WEB SERVICES ARE
PROVIDED "AS-IS", AND NEITHER WE NOR ANY OF OUR LICENSORS MAKE ANY
REPRESENTATION OR WARRANTY WITH RESPECT TO SUCH THE WEB SERVICES.
THE SERVICE PROVIDER AND ITS LICENSORS SPECIFICALLY DISCLAIM, TO THE
FULLEST EXTENT PERMITTED BY LAW, ANY AND ALL WARRANTIES, EXPRESS OR
IMPLIED, RELATING TO THE WEB SERVICES, INCLUDING BUT NOT LIMITED TO,
IMPLIED WARRANTIES OF MERCHANTABILITY, COMPLETENESS, TIMELINESS,
CORRECTNESS, NON-INFRINGEMENT, OR FITNESS FOR ANY PARTICULAR PURPOSE.
THE SERVICE PROVIDERS AND ITS LICENSORS DO NOT REPRESENT OR WARRANT
THAT THE WEB SERVICES: (A) WILL BE SECURE, TIMELY, UNINTERRUPTED OR
ERROR-FREE OR OPERATE IN COMBINATION WITH ANY OTHER HARDWARE,
SOFTWARE, SYSTEM OR DATA, (B) WILL MEET YOUR REQUIREMENTS OR
EXPECTATIONS, OR (C) WILL BE FREE OF VIRUSES OR OTHER HARMFUL
COMPONENTS. THESE DISCLAIMERS CONSTITUTE AN ESSENTIAL PART OF THIS
AGREEMENT. IF IMPLIED WARRANTIES MAY NOT BE DISCLAIMED UNDER
APPLICABLE LAW, THEN ANY IMPLIED WARRANTIES ARE LIMITED IN DURATION TO
THE PERIOD REQUIRED BY APPLICABLE LAW. SOME STATES OR JURISDICTIONS DO
NOT ALLOW LIMITATIONS ON HOW LONG AN IMPLIED WARRANTY MAY LAST, SO THE
ABOVE LIMITATIONS MAY NOT APPLY TO YOU. FURTHER, CUSTOMER
ACKNOWLEDGES AND AGREES THAT THAT RESULTS HAS NO CONTROL OVER THE
INTERNET, AND THAT RESULTS IS NOT LIABLE FOR THE DISCONTINUANCE OF
OPERATION OF ANY PORTION OF THE INTERNET OR POSSIBLE REGULATION OF THE
INTERNET WHICH MIGHT RESTRICT OR PROHIBIT THE OPERATION OF THE
SERVICES.
39. Limitation of Liability. IN NO EVENT SHALL THE SERVICE PROVIDER AND/OR ITS
LICENSORS BE LIABLE TO ANYONE FOR ANY DIRECT, INDIRECT, PUNITIVE, SPECIAL,
EXEMPLARY, INCIDENTAL, CONSEQUENTIAL OR OTHER DAMAGES OF ANY TYPE OR
KIND (INCLUDING LOSS OF DATA, REVENUE, PROFITS, USE OR OTHER ECONOMIC
ADVANTAGE) ARISING OUT OF, OR IN ANY WAY CONNECTED WITH THE WEB
SERVICES, INCLUDING WITHOUT LIMITATION THE USE OR INABILITY TO USE THE
WEB SERVICES, OR FOR ANY CONTENT OBTAINED FROM OR THROUGH THE WEB
SERVICES, ANY INTERRUPTION, INACCURACY, ERROR OR OMISSION, REGARDLESS
OF CAUSE, EVEN IF THE PARTY FROM WHICH DAMAGES ARE BEING SOUGHT OR 
2014 SAAS TERMS OF SERVICE AGREEMENT
SUCH PARTY'S LICENSORS HAVE BEEN PREVIOUSLY ADVISED OF THE POSSIBILITY
OF SUCH DAMAGES.
40. Force Majeure. We shall not be liable for damages for any delay or failure of delivery
arising out of causes beyond our reasonable control and without our fault or negligence,
including, but not limited to, Acts of God, acts of civil or military authority, fires, riots, wars,
embargoes, Internet disruptions, hacker attacks, or communications failures.
41. Survival. Those clauses the survival of which is necessary for the interpretation or
enforcement of this Agreement shall continue in full force and effect in accordance with their
terms notwithstanding the expiration or termination hereof, such clauses to include, without
limitation, the following: Warranty Disclaimers, Limitation of Liability, Confidential Information,
Security, Notices, Arbitration, Applicable Law, Jurisdiction and Venue, Severability, Force
Majeure, and Miscellaneous.
42. U.S. Government End-Users. We provide the Web Services, including related software
and technology, for ultimate federal government end use solely in accordance with the
following: Government technical data and software rights related to the Web Services include
only those rights customarily provided to the public as defined in this Agreement. This
customary commercial license is provided in accordance with FAR 12.211 (Technical Data)
and FAR 12.212 (Software) and, for Department of Defense transactions, DFAR 252.227-7015
(Technical Data Commercial Items) and DFAR 227.7202-3 (Rights in Commercial Computer
Software or Computer Software Documentation). If a government agency has a need for rights
not conveyed under these terms, it must negotiate with us to determine if there are acceptable
terms for transferring such rights, and a mutually acceptable written addendum specifically
conveying such rights must be included in any applicable contract or agreement. Unpublishedrights reserved under the copyright laws of the United States.
43. Miscellaneous. This Agreement constitutes the entire understanding of the parties with
respect to the subject matter of this Agreement and merges all prior communications,
understandings, and agreements. This Agreement may be modified only by a written
agreement signed by the parties. The failure of either party to enforce at any time any of the
provisions hereof shall not be a waiver of such provision, or any other provision, or of the right
of such party thereafter to enforce any provision hereof. The application the United Nations
Convention of Contracts for the International Sale of Goods is expressly excluded. This license
is written in English, and English is its controlling language.

  `;
</script>
